import { render } from "./MockExams.vue?vue&type=template&id=de3e9490&scoped=true&ts=true"
import script from "./MockExams.vue?vue&type=script&lang=ts"
export * from "./MockExams.vue?vue&type=script&lang=ts"

import "./MockExams.vue?vue&type=style&index=0&id=de3e9490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de3e9490"]])

export default __exports__